import { parseApiErrorResponse } from './parse-api-error-response';

/**
 * Best-effort message from a failed JSON API response body.
 */
export async function readApiErrorMessage(response: Response): Promise<string> {
  const { reason } = await parseApiErrorResponse(response);
  if (reason) {
    return reason;
  }

  if (response.status) {
    return `Request failed (HTTP ${response.status})`;
  }

  return 'Request failed';
}
